// Format field names for display
export const formatFieldName = (field) => {
    return field
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

// Format value for display
export const formatValue = (value) => {
    if (Array.isArray(value)) {
        return value.join(', ');
    }
    if (typeof value === 'boolean') {
        return value ? 'Yes' : 'No';
    }
    if (typeof value === 'number') {
        if (Number.isFinite(value) && !Number.isInteger(value)) {
            return value.toFixed(2);
        }
        return value.toString();
    }
    if (value && typeof value === 'object') {
        try {
            return JSON.stringify(value, null, 2);
        } catch (error) {
            console.error('Failed to stringify value for display.', error);
            return String(value);
        }
    }
    return value;
};

export const formatConfidence = (value) => {
    const numeric = Number(value);

    if (!Number.isFinite(numeric)) {
        return formatValue(value);
    }

    if (numeric >= 0 && numeric <= 1) {
        return `${Math.round(numeric * 100)}%`;
    }

    if (numeric > 1 && numeric <= 100) {
        return `${Math.round(numeric)}%`;
    }

    return formatValue(value);
};

// Get badge color based on value
export const getBadgeColor = (field, value) => {
    if (field === 'looks_good') {
        if (value === 'excellent') return '#28a745';
        if (value === 'good') return '#17a2b8';
        if (value === 'fair') return '#ffc107';
        return '#dc3545';
    }
    if (typeof value === 'boolean') {
        return value ? '#28a745' : '#6c757d';
    }
    return '#17a2b8';
};

export const formatDurationMs = (value) => {
    const numeric = Number(value);

    if (!Number.isFinite(numeric)) {
        return '—';
    }

    if (numeric >= 1000) {
        const seconds = numeric / 1000;
        return seconds >= 10 ? `${seconds.toFixed(1)} s` : `${seconds.toFixed(2)} s`;
    }

    if (numeric <= 0) {
        return '0 ms';
    }

    if (numeric < 1) {
        return `${numeric.toFixed(2)} ms`;
    }

    return `${Math.round(numeric)} ms`;
};

export const getCoreWebVitalStatus = (config, value) => {
    const numeric = Number(value);

    if (!Number.isFinite(numeric)) {
        return { label: 'No data', color: '#6c757d', textColor: '#fff' };
    }

    const { thresholds } = config;

    if (!thresholds) {
        return { label: '—', color: '#6c757d', textColor: '#fff' };
    }

    if (numeric <= thresholds.good) {
        return { label: 'Good', color: '#28a745', textColor: '#fff' };
    }

    if (numeric <= thresholds.needsImprovement) {
        return { label: 'Needs Improvement', color: '#ffc107', textColor: '#0b0b0b' };
    }

    return { label: 'Poor', color: '#dc3545', textColor: '#fff' };
};

export const formatCoreWebVitalValue = (config, value) => {
    if (value === null || value === undefined) {
        return '—';
    }

    if (config.format === 'duration') {
        return formatDurationMs(value);
    }

    if (config.format === 'score') {
        return Number.isFinite(Number(value)) ? Number(value).toFixed(3) : '—';
    }

    return String(value);
};






